import { StructuredStorageBaseHelper } from './StructuredStorageBaseHelper';
export class KeyStructuredStorageBaseHelper extends StructuredStorageBaseHelper {
    constructor({ keyType, knownKeyType, ...rest }) {
        super(rest);
        this.keyType = keyType;
        this.knownKeyType = knownKeyType;
    }
}

//# sourceMappingURL=KeyStructuredStorageBaseHelper.js.map
